module.exports = __webpack_public_path__ + "officialStatic/img/case41.0cd5338.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case41.jpg
// module id = 84UU
// module chunks = 0